export const MENU_CONFIG = {
  "doctor-office_appointment-admin": {
    path: "/appointment-admin",
    label: "Administración de Citas",
    icon: "fa-calendar",
  },
  "doctor-office_appointment-internal": {
    path: "/appointment-internal",
    label: "Citas Médicas",
    icon: "fa-stethoscope",
  },
  "doctor-office_electronic-recipes": {
    path: "/electronic-recipes",
    label: "Recetas Digitales",
    icon: "fa-file-text-o",
  },
  "doctor-office_appointment-histories": {
    path: "/appointment-histories",
    label: "Historia Clínica",
    icon: "fa-history",
  },
  "doctor-office_monthly_closing": {
    path: "/monthly-closing",
    label: "Cierre Mensual",
    icon: "fa fa-calendar",
  },
  purchasing_prescriptions: {
    path: "/purchasing-prescriptions",
    label: "Compras de Recetarios",
    icon: "fa-shopping-cart",
  },
};
